.TopToolbar,
.TopToolbar:global(.MuiToolbar-root) {
    z-index: calc(var(--soniq-t--global--z-index--drawer) - 1);
    position: sticky;
    inset: 0 0 auto 0;
    border-bottom: solid 1px var(--soniq-t--global--border--color--emphasis--default);
    gap: 1rem;

    /* Room for the app menu button (left) and the actions
       drawer button (right), which sit over the toolbar. */
    @media (max-width: 768px) {
        width: 100vw;
        max-width: 100%;
        padding-left: 3rem;
        padding-right: 3rem;
    }
}

/* Takes the free space left of the actions and centres the
   search button in it. The button caps its own width. */
.TopToolbar__search {
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    min-width: 0;
}

/* Visually hidden, still read by screen readers */
.TopToolbar__hiddenHeading {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}

/* Shown only when global search is turned off */
.TopToolbar__heading {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.TopToolbar__actions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;

    &:empty {
        display: none;
    }
}
